import type { KeyboardEvent, SyntheticEvent } from 'react';

/** Enter or Space on the element, as opposed to a click or tap. */
export const isKeyboardActivation = (event: SyntheticEvent) => event.type === 'keydown';

export const activationProps = <T extends HTMLElement>(
  onActivate: (event: SyntheticEvent<T>) => void,
  onKeyDown?: (event: KeyboardEvent<T>) => void,
) => ({
  role: 'button' as const,
  tabIndex: 0,
  onClick: onActivate,
  onKeyDown: (event: KeyboardEvent<T>) => {
    onKeyDown?.(event);
    if (event.target !== event.currentTarget) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onActivate(event);
  },
});
